<template>
  <ul class="participation__list">
    <ShapeListItem
      class="participation__item"
      v-for="(participant, index) in participants"
      :item="participant"
      :index="index"
      :key="index"
    />
  </ul>
</template>

<script>
import ShapeListItem from '~/components/ShapeListItem'

export default {
  name: 'ParticipationList',
  components: {
    ShapeListItem
  },
  computed: {
    participants() {
      return this.messages.index.participation.participants
    }
  }
}
</script>



// WEBPACK FOOTER //
// components/ParticipationList.vue